import { useEffect, useState } from "react";

/**
 * Viewport-based mobile detection (avoid UA sniffing).
 * Default breakpoint matches common tablet/phone cutover.
 */
export function useIsMobile(maxWidthPx = 768) {
  const getMatches = () => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(`(max-width: ${maxWidthPx}px)`).matches;
  };

  const [isMobile, setIsMobile] = useState(getMatches);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(`(max-width: ${maxWidthPx}px)`);

    const onChange = () => setIsMobile(mql.matches);

    // Modern + legacy Safari
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);

    setIsMobile(mql.matches);

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [maxWidthPx]);

  return isMobile;
}


